import React from 'react';
import { LoomVideoPreview } from '../../apps/dashboard/components/LoomVideo';
import ReactPlayer from 'react-player';
import { isLoomUrl } from '../../apps/dashboard/components/LoomVideo/isLoomUrl';
import { mapLoomVideoFromUrl } from '../../apps/dashboard/components/LoomVideo/mappings';

export type VideoPlayerProps = {
  url: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  onPlay?: () => void;
};

export const VideoPlayer: React.FC<
  React.PropsWithChildren<VideoPlayerProps>
> = ({ url, width = '100%', height = '100%', className = '', onPlay }) => {
  if (!url) return null;

  if (isLoomUrl(url)) {
    return (
      <LoomVideoPreview
        loomVideo={mapLoomVideoFromUrl(url)}
        previewWidth={typeof width === 'number' ? width : undefined}
        previewHeight={typeof height === 'number' ? height : undefined}
        className={className}
        onPlay={onPlay}
      />
    );
  }

  return (
    <ReactPlayer
      url={url}
      width={width}
      height={height}
      className={`overflow-hidden ${className}`}
      controls
      onPlay={onPlay}
    />
  );
};
